export default (state) => ({
  clearlinkId: state.clearlinkId,
  referralCode: state.referralCode,
  forcedMarket: state.forcedMarket,
  ecommerceItem: state.ecommerceItem,
  businessOffers: state.businessOffers,
  marketOverrides: state.marketOverrides,
  clearlinkOfferId: state.clearlinkOfferId,
  residentialOffers: state.residentialOffers,
  quickAddressInUsed: state.quickAddressInUsed,
  quickAddressInError: state.quickAddressInError,
  selectedOfferIsAvailable: state.selectedOfferIsAvailable,
  showTvNotAvailableModal: state.showTvNotAvailableModal,
  meta: {
    uuid: state.meta.uuid,
    offerId: state.meta.offerId,
    lastName: state.meta.lastName,
    channels: state.meta.channels,
    rateCard: state.meta.rateCard,
    features:  state.meta.features,
    firstName: state.meta.firstName,
    phoneNumber: state.meta.phoneNumber,
    billingCity: state.meta.billingCity,
    emailAddress: state.meta.emailAddress,
    billingLine1: state.meta.billingLine1,
    billingLine2: state.meta.billingLine2,
    referralCode: state.meta.referralCode,
    channelLineup: state.meta.channelLineup,
    conversationId: state.meta.conversationId,
    mobileEligible: state.meta.mobileEligible,
    referralCodeUsed: state.meta.referralCodeUsed,
    billingPostalCode: state.meta.billingPostalCode,
    createdConversation: state.meta.createdConversation,
    billingStateOrProvince: state.meta.billingStateOrProvince,
    acsid: state.meta.acsid,
    impactRadiusClickId: state.meta.impactRadiusClickId,
    pendingDisconnect: {
      date: state.meta.pendingDisconnect.date,
      hasPendingDisconnect: state.meta.pendingDisconnect.hasPendingDisconnect,
    },
    abandonedCart: {
        giftCardTrigger: state.meta.abandonedCart.giftCardTrigger,
    },
    houseKey: state.meta.houseKey,
    statusCode: state.meta.statusCode,
    dwellingType: state.meta.dwellingType,
    isRightOfEntry: state.meta.isRightOfEntry,
    roeRedirect: state.meta.roeRedirect,
    isAbandonedCart: state.meta.isAbandonedCart,
  },
  Buyflow: {
    decisions: state.Buyflow.decisions,
    fromMobileLP: state.Buyflow.fromMobileLP,
    mobileEligible: state.meta.mobileEligible ?? state.Buyflow.mobileEligible,
    mobileInterested: state.Buyflow.mobileInterested,
    session: {
      returnToUrl: state.Buyflow.session.returnToUrl,
      showNotification: state.Buyflow.session.showNotification,
      hasCompletedOrder: state.Buyflow.session.hasCompletedOrder,
    },
    receipt: {
      cartData: state.Buyflow.receipt.cartData,
    },
    internet: {
      data: state.Buyflow.internet.data,
    },
    tv: {
      data: state.Buyflow.tv.data,
      tvOptions: {
        declined: state.Buyflow.tv.tvOptions.declined,
      },
    },
    voice: {
      data: state.Buyflow.voice.data,
      voiceOptions: {
        declined: state.Buyflow.voice.voiceOptions.declined,
      },
    },
    finalize: {
      installData: state.Buyflow.finalize.installData,
      scheduleTimes: state.Buyflow.finalize.scheduleTimes,
      confirmedDateTime: state.Buyflow.finalize.confirmedDateTime,
    },
  },
  BroadbandLabels: {
    labelData: state.BroadbandLabels.labelData,
    labelRequest: state.BroadbandLabels.labelRequest,
    allLabels: state.BroadbandLabels.allLabels,
    labelError: state.BroadbandLabels.labelError,
    pendingLabelRequest: state.BroadbandLabels.pendingLabelRequest,
    pendingLabelRequestGroup: state.BroadbandLabels.pendingLabelRequestGroup
  },
  Promotions: {
    promotions: state.Promotions.promotions,
    activePromotions: state.Promotions.activePromotions,
    loadingPromotions: state.Promotions.loadingPromotions,
    promotionsError: state.Promotions.promotionsError,
    appliedPromotions: state.Promotions.appliedPromotions,
    hasLoaded: state.Promotions.hasLoaded,
    selectedGiftOption: state.Promotions.selectedGiftOption,
    showGiftChoicePopup: state.Promotions.showGiftChoicePopup
  }
})
